<template>
    <div class="ms-4 mt-4 full-height-container">
        <!--        <h2>{{titleLabel}}</h2>-->
        <h2>What type of app do you want to build?</h2>

        <div class="row">
            <div class="col-sm-12 col-md-3 my-4">

                <div class="card shadow w-100 h-100 pointer hoverable" @click="app.app_type = 'Website'"
                     :class="app.app_type === 'Website' ? 'selected-app-type' : ''">
                    <div class="card-body">
                        <h5 class="card-title"><strong>Website with Forms</strong> <i
                                v-if="app.app_type === 'Website'" class="me-2 fas fa-rocket text-primary"></i></h5>
                        <h6 class="card-subtitle my-3 text-muted">Best for: marketing site</h6>
                        <!--                        <div class="card-text">-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> A modern mobile-friendly <strong>website</strong>-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> On a custom domain-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> With beautiful templates-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> lead collection forms-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> full customization support-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> Great for a Marketing Sites-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-3 my-4">
                <div class="card shadow w-100 pointer hoverable" @click="app.app_type = 'Private App'"
                     :class="app.app_type === 'Private App' ? 'selected-app-type' : ''">
                    <div class="card-body">
                        <h5 class="card-title"><strong>Private Web Application</strong> <i
                                v-if="app.app_type === 'Private App'" class="me-2 fas fa-rocket text-primary"></i></h5>
                        <h6 class="card-subtitle my-3 text-muted">Best for: Internal Apps</h6>
                        <!--                        <div class="card-text">-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> A modern <strong>web-->
                        <!--                                application</strong>-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> Hosted on WeBase-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> with custom data models-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> custom screens-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> open to only invited users-->
                        <!--                                users-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> full customization support-->
                        <!--                            </div>-->
                        <!--                            <div class="my-1">-->
                        <!--                                <i class="far fa-check-circle text-success me-2"></i> Great for internal applications-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                    </div>
                </div>
            </div>

<!--            <div v-if="isAdmin" class="col-sm-12 col-md-3 my-4">-->
<!--                <div class="card shadow w-100 h-100 pointer hoverable" @click="app.app_type = 'Web3 App'"-->
<!--                     :class="app.app_type === 'Web3 App' ? 'selected-app-type' : ''">-->
<!--                    <div class="card-body">-->
<!--                        <h5 class="card-title"><strong>NFT Application</strong> <i-->
<!--                                v-if="app.app_type === 'Website'" class="me-2 fas fa-rocket text-primary"></i></h5>-->
<!--                        <h6 class="card-subtitle my-3 text-muted">Best for creators selling NFTs</h6>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <!--            <div class="col-sm-12 col-md-3 my-4">-->
            <!--                <div class="card shadow w-100 pointer hoverable" @click="app.app_type = 'Public App'"-->
            <!--                     :class="app.app_type === 'Public App' ? 'selected-app-type' : ''">-->
            <!--                    <div class="card-body">-->
            <!--                        <h5 class="card-title"><strong>Public Web Application</strong> <i-->
            <!--                                v-if="app.app_type === 'Public App'" class="me-2 fas fa-rocket text-primary"></i></h5>-->
            <!--                        <h6 class="card-subtitle my-3 text-muted">Best for: SAAS product</h6>-->

            <!--                        <div class="card-text">-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> A modern <strong>web-->
            <!--                                application</strong>-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> On a custom domain-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> with custom data models-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> custom screens-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> open to all users-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> full customization support-->
            <!--                            </div>-->
            <!--                            <div class="my-1">-->
            <!--                                <i class="far fa-check-circle text-success me-2"></i> Great for a SAAS product-->
            <!--                            </div>-->
            <!--                        </div>-->

            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->

        </div>

        <div v-if="isNew && app.app_type === 'Website'" class="my-2">
            <h4>Pick a template or start from scratch.</h4>
        </div>
        <div v-if="isNew && app.app_type === 'Website'" class="mb-3 d-flex flex-nowrap">

            <div style="width: 18rem;"
                 :class="currentSiteTemplate === null ? 'selected-app-type' : ''"
                 @click="onTemplateClick(null)" class="card me-2 mb-2 pointer hoverable">

                <div class="card-body p-2">
                    <svg class="bd-placeholder-img card-img-top" width="100%" height="180"
                         xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: Image cap"
                         preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title>
                        <rect width="100%" height="100%" fill="#cccccc"></rect>
                        <text x="10%" y="50%" fill="#333333" dy=".3em">Custom Template</text>
                    </svg>

                    <h6 class="card-subtitle my-2 text-muted">Start from scratch</h6>
                </div>
            </div>

            <div v-for="websiteTemplate in model.websiteTemplates" style="width: 18rem;"
                 :class="currentSiteTemplate && websiteTemplate.id === currentSiteTemplate.id ? 'selected-app-type' : ''"
                 @click="onTemplateClick(websiteTemplate)" class="card me-2 mb-2 pointer hoverable">

                <div class="card-body p-2">
                    <img class="w-100" v-if="websiteTemplate.featured_image" :src="websiteTemplate.featured_image">
                    <h6 class="card-subtitle my-2 text-muted">{{ websiteTemplate.name }}</h6>
                    <a :href="livePreviewUrl(websiteTemplate)" class="card-link btn btn-primary btn-sm" target="_blank">Live
                        Preview</a>
                </div>
            </div>
        </div>

        <div v-if="isNew && app.app_type === 'Private App'" class="mb-3 d-flex flex-nowrap">


            <div :class="currentSiteTemplate === null ? 'selected-app-type' : ''"
                 @click="onTemplateClick(null)" class="card me-2 pointer hoverable">
                <div class="p-3">
                    <div style="width: 180px; height: 180px;"
                         class="shadow-sm d-flex flex-column align-items-center justify-content-center app-box rounded-extra p-1">
                        <div style="width: 80px; height: 80px;" class="rounded-extra"
                             :style="{ backgroundColor: '#5674F040' }">
                            <div class="d-flex flex-column align-items-center mx-auto h-100">
                                <i class="fa fas fa-rocket m-auto fa-2x" :style="{ color: '#5674F0' }"></i>
                            </div>
                        </div>
                        <div class="font-weight-bold text-center text-sm mt-2">
                            Start from Scratch
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="appTemplate in model.appTemplates"
                 :class="currentSiteTemplate && appTemplate.id === currentSiteTemplate.id ? 'selected-app-type' : ''"
                 @click="onTemplateClick(appTemplate)" class="card me-2 pointer hoverable">
                <div class="p-3">
                    <a href="javascript:void(0)" class="no-underline">
                        <app-display :app="appTemplate"></app-display>
                    </a>
                </div>
            </div>
        </div>


        <div class="row mb-5">
            <div class="col-sm-12 col-md-6">

                <form>

                    <div class="form-row">
                        <div class="mb-3 col-md-6">
                            <label class="form-label" for="nameInput">Name</label>
                            <input type="text" class="form-control" id="nameInput" placeholder="Name of app"
                                   v-model="app.name">
                        </div>

                        <div class="mb-3 col-md-6">
                            <label class="form-label" for="iconOptions">Type of Application</label>

                            <select id="typeOptions" class="form-select" v-model="app.app_type">
                                <option>Website</option>
                                <option>Private App</option>
                                <!--                                <option>Public App</option>-->
                                <option v-if="isAdmin">Web3 App</option>
                            </select>
                        </div>

                    </div>

                    <div v-if="!isNew" class="form-group">
                        <label class="form-label" for="descriptionInput">Description</label>
                        <input type="text" class="form-control" id="descriptionInput" placeholder="description"
                               v-model="app.description">
                    </div>

                    <div v-if="!isNew" class="form-row">
                        <div class="mb-3 col-md-2">
                            <label class="form-label" for="iconOptions">Icon</label>

                            <select id="iconOptions" class="form-select" v-model="app.icon_class">
                                <option v-for="iconOption in model.iconOptions">{{ iconOption }}</option>
                            </select>
                        </div>

                        <div class="mb-3 col-md-2">
                            <label class="form-label">Theme color</label>
                            <div>
                                <color-picker :color-object="app" color-field="theme_color"></color-picker>
                            </div>
                        </div>
                    </div>

                    <div v-if="!isNew" class="mb-3">
                        <a href="javascript:void(0)" @click="showAdvanced = !showAdvanced">{{ advancedLabel }}</a>
                    </div>

                    <div v-if="showAdvanced && app.wlc" class="my-2">
                        <button class="btn btn-primary btn-wide" @click.prevent="onEditWhitelabelClick">Edit White Label Config
                        </button>
                    </div>

                    <div v-if="app.id && hasCustomView && showAdvanced" class="form-group form-check">
                        <input class="form-check-input" type="checkbox" id="showTabsCheckbox"
                               v-model="app.hide_tab_navigation">
                        <label class="form-check-label" for="showTabsCheckbox">
                            Hide tab navigation
                        </label>
                    </div>

                    <div v-if="showAdvanced" class="form-group my-1">
                        <label for="defaultViewOptions">Default View</label>

                        <select id="defaultViewOptions" class="form-select" v-model="app.default_view_id">
                            <option v-for="view in views" :value="view.id">{{ view.name }}</option>
                        </select>
                    </div>

                    <div v-if="showAdvanced && isAppOwner" class="form-group my-1">
                        <label for="appPermissionOptions">Default App Permission</label>

                        <select id="appPermissionOptions" class="form-select" v-model="app.default_app_permission_id">
                            <option v-for="permission in appPermissions" :value="permission.id">
                                {{ permission.permission }}
                            </option>
                        </select>
                    </div>

                    <div v-if="showAdvanced && isAppOwner" class="form-group my-1">
                        <label for="dataPermissionOptions">Default Data Permission</label>

                        <select id="dataPermissionOptions" class="form-control"
                                v-model="app.default_data_permission_id">
                            <option v-for="permission in dataPermissions" :value="permission.id">
                                {{ permissionLabel(permission) }}
                            </option>
                        </select>
                    </div>

                    <!-- This feature is confusing and I don't think it even works... uncomment IF/WHEN baked -->

                    <!--                    <div v-if="showAdvanced && isAppOwner" class="form-group">-->
                    <!--                        <nav-editor :app="app" :tabs="app.nav.tabs"></nav-editor>-->
                    <!--                    </div>-->


                    <div class="d-flex form-group mt-2">
                        <button type="submit" class="btn btn-primary btn-wide"
                                @click.prevent="onSaveClick">Save
                        </button>

                        <router-link :to="cancelRoute" class="btn btn-secondary btn-wide mx-2">
                            Cancel
                        </router-link>

                        <div v-if="app.id && showAdvanced" class="ms-auto mt-2">
                            <button class="btn btn-sm btn-danger" @click.prevent="onDeleteClick">delete app</button>
                        </div>
                    </div>

                </form>


            </div>

            <div v-if="!isNew" class="col-sm-12 col-md-6">
                <app-display :app="app"></app-display>

                <div class="my-3" v-if="appId">
                    <a class="btn btn-primary btn-sm" :href="createTemplateUrl" target="_blank">Create App Template</a>
                </div>
            </div>
        </div>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteApp"
                text="Are you sure you want to delete this app?">
        </confirm-modal>

        <white-label-modal v-if="showWhitelabelModal" @noEvent="showWhitelabelModal = false" :yes-event="onWhitelabelConfigSaved"
                           :white-label-config="app.whitelabel_config"></white-label-modal>
    </div>
</template>

<script>

import AppService from "../../services/AppService";
import ColorPicker from "../../components/ColorPicker.vue";
import AppDisplay from "../../components/AppDisplay.vue";
import AppTemplateService from "../../services/AppTemplateService";
import ConfirmModal from "../../components/ConfirmModal.vue";
import WebsiteTemplateService from "../../services/WebsiteTemplateService";
import NavEditor from "./NavEditor.vue";
import WhiteLabelModal from "../../components/WhiteLabelModal.vue";

export default {
    name: 'AppForm',
    components: {WhiteLabelModal, NavEditor, ConfirmModal, AppDisplay, ColorPicker},
    data() {
        return {
            model: webase.model,
            titleLabel: 'New App',
            appId: null,
            showAdvanced: false,
            app: {
                id: null,
                name: '',
                icon_class: '',
                theme_color: '',
                description: '',
                details: '',
                publish_as_template: false,
                hide_tab_navigation: false,
                default_view_id: null,
                app_type: null,
                app_template_id: null,
                wlc: false,
                whitelabel_config: null
            },
            service: new AppService(),
            showConfirmModal: false,
            deleteApp: function () {
            },
            currentSiteTemplate: null,
            showWhitelabelModal: false,
            onWhitelabelConfigSaved: () => {
                this.loadApp()
            },
        }
    },
    computed: {
        isNew() {
            return this.app.id === null
        },
        cancelRoute() {
            if (this.appId) {
                return {name: 'app-editor', params: {id: this.appId}}
            }

            return {name: 'apps'}
        },
        isAdmin() {
            return this.model.currentUser && webase.utils.user.isAdmin()
        },
        isAppOwner() {
            return webase.managers.permission.isOwnerOrAdmin()
        },
        advancedLabel() {
            return this.showAdvanced ? 'Hide' : 'Advanced'
        },
        views() {
            return webase.managers.app.getViews()
        },
        hasCustomView() {
            return webase.managers.app.hasCustomView()
        },
        appPermissions() {
            return webase.managers.permission.appPermissions()
        },
        dataPermissions() {
            return webase.managers.permission.dataPermissions()
        },
        createTemplateUrl() {
            return '/marketplace/new?app_id=' + this.appId
        },
    },
    mounted() {
        if (this.$route.params.id) {
            this.titleLabel = 'Edit App'
            this.appId = this.$route.params.id
            this.loadApp()
        } else {
            this.app.icon_class = webase.utils.array.random(webase.model.iconOptions)
            this.app.theme_color = webase.utils.array.random(webase.model.defaultColors)

            let siteTemplateService = new WebsiteTemplateService()

            siteTemplateService.list().then((websiteTemplates) => {
                this.model.websiteTemplates = websiteTemplates
            }).catch((error) => {
                console.log('Error loading website templates.')
                console.log(error)
            })
        }

        let templateService = new AppTemplateService()
        templateService.list().then((templates) => {
            this.model.appTemplates = templates
        }).catch((error) => {
            console.log('Error loading app templates.')
            console.log(error)
        })
    },
    methods: {
        loadApp() {
            this.service.get(this.appId).then((response) => {

                if (response.nav.tabs === undefined) {
                    response.nav.tabs = []
                }

                if (response.nav.location === undefined || response.nav.location === '') {
                    response.nav.location = 'side'
                }

                this.app = response

                if (!this.app.icon_class) {
                    this.updateAppStyle()
                }

            }).catch((message) => {
                console.log('error loading app')
                console.log(message)
            })
        },
        onEditWhitelabelClick() {
            this.showWhitelabelModal = true
        },
        onSaveClick() {
            let request = {
                app: this.app
            }

            let promise = this.appId === null ? this.service.create(request) : this.service.update(this.appId, request)

            promise.then((response) => {
                this.app = response

                if (this.app.app_type === 'Website') {
                    this.$router.push({name: 'open-site', params: {id: this.app.website_id}})
                }
                // else if (this.app.app_type === 'Web3 App') {
                //     this.$router.push({name: 'web3-app', params: {id: this.app.id}})
                // }
                else {
                    this.$router.push({name: 'app-editor', params: {id: this.app.id}})
                }
            }).catch((message) => {
                console.log('error saving app')
                console.log(message)
                webase.utils.notification.error(message)
            })
        },
        updateAppStyle() {
            this.app.icon_class = webase.utils.array.random(webase.model.iconOptions)
            this.app.theme_color = webase.utils.array.random(webase.model.defaultColors)

            let request = {
                app: this.app
            }

            this.service.update(this.appId, request)
        },
        onPublishClick() {
            let request = {
                app_template: {
                    app_id: this.appId
                }
            }

            let service = new AppTemplateService()
            service.create(request).then((response) => {
                let templateUrl = webase.utils.app.getBaseUrl() + '/marketplace/' + response.slug + '/edit'
                window.open(templateUrl)
            }).catch((error) => {
                console.log('Error creating template.')
                console.log(error)
            })
        },
        onDeleteClick() {
            this.showConfirmModal = true

            this.deleteApp = () => {
                console.log('delete app, id: ' + this.app.id)
                this.service.remove(this.app.id).then(() => {
                    webase.utils.array.remove(this.model.apps, this.app.id)
                    this.showConfirmModal = false
                    this.$router.push({name: 'apps'})
                }).catch((error) => {
                    console.log('Error removing app.')
                    console.log(error)
                    this.showConfirmModal = false
                })
            }
        },

        onTemplateClick(siteTemplate) {

            if (siteTemplate) {
                this.currentSiteTemplate = siteTemplate
                this.app.app_template_id = siteTemplate.id
            } else {
                this.currentSiteTemplate = null
                this.app.app_template_id = null
            }


            // this.showTemplateModal = true

            // this.onSiteImport = () => {
            //     this.siteService.copyPages(this.model.website.slug, this.currentSiteTemplate.slug).then((website) => {
            //         console.log('Copied pages into website from template.')
            //         console.log(website)
            //         // this.$router.push({name: 'open-app', params: {id: app.id}})
            //         this.$router.push({ name: 'open-site', params: {id: this.model.website.slug}})
            //     }).catch((error) => {
            //         console.log('Error copying pages into website from template.')
            //         console.log(error)
            //     })
            // }
        },

        livePreviewUrl(siteTemplate) {
            return siteTemplate.preview_url
        },

        permissionLabel(permission) {
            if (permission && permission.permission === 'VEUO') {
                return 'view and edit user only'
            }

            return permission.permission
        }
    }
}
</script>
